/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllVasServiceResponseResponseDto } from '../model/allVasServiceResponseResponseDto';
import { CreateVasServiceResponseDto } from '../model/createVasServiceResponseDto';
import { VasServiceResponseResponseDto } from '../model/vasServiceResponseResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceResponseService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseCreateServiceResponsePost(body?: CreateVasServiceResponseDto, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseResponseDto>;
    public apiVasServiceResponseCreateServiceResponsePost(body?: CreateVasServiceResponseDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseCreateServiceResponsePost(body?: CreateVasServiceResponseDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseCreateServiceResponsePost(body?: CreateVasServiceResponseDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VasServiceResponseResponseDto>('post',`${this.basePath}/api/VasServiceResponse/CreateServiceResponse`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param responseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseDeleteServiceResponseResponseIdDelete(responseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiVasServiceResponseDeleteServiceResponseResponseIdDelete(responseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiVasServiceResponseDeleteServiceResponseResponseIdDelete(responseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiVasServiceResponseDeleteServiceResponseResponseIdDelete(responseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (responseId === null || responseId === undefined) {
            throw new Error('Required parameter responseId was null or undefined when calling apiVasServiceResponseDeleteServiceResponseResponseIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/VasServiceResponse/DeleteServiceResponse/${encodeURIComponent(String(responseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetAllVasServiceResponseGet(observe?: 'body', reportProgress?: boolean): Observable<AllVasServiceResponseResponseDto>;
    public apiVasServiceResponseGetAllVasServiceResponseGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllVasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetAllVasServiceResponseGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllVasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetAllVasServiceResponseGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllVasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetAllVasServiceResponse`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param responseId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet(vasServiceId: string, responseId: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseResponseDto>;
    public apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet(vasServiceId: string, responseId: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet(vasServiceId: string, responseId: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet(vasServiceId: string, responseId: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet.');
        }

        if (responseId === null || responseId === undefined) {
            throw new Error('Required parameter responseId was null or undefined when calling apiVasServiceResponseGetVasServiceByServiceIdAndResponseIdVasServiceIdResponseIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetVasServiceByServiceIdAndResponseId/${encodeURIComponent(String(vasServiceId))}/${encodeURIComponent(String(responseId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param responseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetVasServiceResponseByResponseIdResponseIdGet(responseId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseResponseDto>;
    public apiVasServiceResponseGetVasServiceResponseByResponseIdResponseIdGet(responseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseByResponseIdResponseIdGet(responseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseByResponseIdResponseIdGet(responseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (responseId === null || responseId === undefined) {
            throw new Error('Required parameter responseId was null or undefined when calling apiVasServiceResponseGetVasServiceResponseByResponseIdResponseIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetVasServiceResponseByResponseId/${encodeURIComponent(String(responseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetVasServiceResponseByServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseResponseDto>;
    public apiVasServiceResponseGetVasServiceResponseByServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseByServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseByServiceIdVasServiceIdGet(vasServiceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceResponseGetVasServiceResponseByServiceIdVasServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetVasServiceResponseByServiceId/${encodeURIComponent(String(vasServiceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetVasServiceResponseServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseResponseDto>;
    public apiVasServiceResponseGetVasServiceResponseServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponseServiceIdVasServiceIdGet(vasServiceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceResponseGetVasServiceResponseServiceIdVasServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetVasServiceResponseServiceId/${encodeURIComponent(String(vasServiceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceResponseGetVasServiceResponsesGet(observe?: 'body', reportProgress?: boolean): Observable<AllVasServiceResponseResponseDto>;
    public apiVasServiceResponseGetVasServiceResponsesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllVasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponsesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllVasServiceResponseResponseDto>>;
    public apiVasServiceResponseGetVasServiceResponsesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllVasServiceResponseResponseDto>('get',`${this.basePath}/api/VasServiceResponse/GetVasServiceResponses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
